import Alpine from 'alpinejs';

Alpine.data('addedToCartModal', () => ({
  productName: undefined,
  productOptions: undefined,
  productPrice: undefined,

  events: {
    ['x-on:keydown.escape.window.prevent']() {
      this.hide();
    },
    ['x-on:added-to-cart-modal:show.window'](event) {
      this.show(event.detail.productName, event.detail.productOptions, event.detail.productPrice);
    }
  },

  show(productName, productOptions, productPrice) {
    this.productName = productName;
    this.productOptions = productOptions;
    this.productPrice = productPrice;

    this.$root.showModal();
  },
  hide() {
    this.$root.close();
  },
}));